import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHandHoldingDollar, faWallet, faCreditCard, faArrowUpFromBracket, faCircleNotch, faUser } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import { useNavigate, useLocation, Link } from 'react-router-dom'
import { toast } from 'react-hot-toast';

function Deposit4() {
  const { user } = useUser();
  const [loading, setLoading] = useState(true);
  const [loading1, setLoading1] = useState(false);
  const { state } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (!localStorage.getItem('upgrade.fileName')) {
        navigate('/plandeposit1', { replace: true })
    }else{
        setLoading(false);
    }
  }, [state, navigate])
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [symbol, setSymbol] = useState(() => {return state?.symbol ?? localStorage.getItem('upgrade.symbol') ?? '';});
  const [method, setMethod] = useState(() => {return state?.method ?? localStorage.getItem('upgrade.method') ?? '';});
  const [plan, setPlan] = useState(() => {return state?.plan ?? localStorage.getItem('upgrade.plan');});
  const [amount, setAmount] = useState(() => {return state?.amount ?? localStorage.getItem('upgrade.amount') ?? '';});
  const [fileName, setFileName] = useState(() => {return state?.fileName ?? localStorage.getItem('upgrade.fileName') ?? '';});
  const [fee, setFee] = useState(() => {return state?.fee ?? localStorage.getItem('withdraw.fee');});

  const ValidateDeposit = () =>{
    setLoading1(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/retirement.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
        "Content-Type": "application/json"
        },
        body: JSON.stringify({ btn_deposit1: true, amount: amount, proof: fileName, method: method, plan : plan })
    })
    .then(response => response.json())
    .then(data => {
        if (data.status === "success") {
        setLoading1(false);
        toast.success(data.result);
        setTimeout(() => {
            navigate('/portfolio', { replace: true })
        }, 2000);
        }else{
        toast.error(data.message);
        setLoading1(false);
        }
    })
    .catch(err => {
        console.error(err)
        setLoading1(false);
    })
  }
  const ValidateDeposit1 = () =>{
    setLoading1(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/retirement.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
        "Content-Type": "application/json"
        },
        body: JSON.stringify({ btn_deposit2: true, amount: amount, proof: fileName, method: method, plan : plan })
    })
    .then(response => response.json())
    .then(data => {
        if (data.status === "success") {
        setLoading1(false);
        toast.success(data.result);
        localStorage.setItem('withdraw.paidfee', true);
        setTimeout(() => {
          navigate('/rwithdraw3', { replace: true, state: { paidfee: true } });
        }, 2000);
        }else{
        toast.error(data.message);
        setLoading1(false);
        }
    })
    .catch(err => {
        console.error(err)
        setLoading1(false);
    })
  }
  
  if (loading) {
    return <div style={{ textAlign: "center", marginTop: "20%" }}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#ff6b35', opacity: '0.5'}} spin /></div>;
  }

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Deposit" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Deposit" icon={<FontAwesomeIcon icon={faHandHoldingDollar} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="container mt-5">
                <div className="row">
                    <div className="col-lg-8 offset-lg-2 mb-5">
                        <h5 className="mb-0" style={{fontWeight:'900'}}>Make a Deposit</h5>
                        <div className="mt-5 d-flex align-items-center progressD" style={{gap:'20px'}}>
                          <Link to="/plandeposit" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px'}}>
                              <FontAwesomeIcon icon={faWallet} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-prime text-nowrap" style={{fontSize:'12px'}}>Deposit Method</p>
                          </Link>
                          <div style={{height:'3px',maxWidth:'200px',width:'100%'}} className="bg-prime"></div>
                          <Link to="/plandeposit1" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',}}>
                              <FontAwesomeIcon icon={faCreditCard} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-prime text-nowrap" style={{fontSize:'12px'}}>Deposit Details</p>
                          </Link>
                          <div className="bg-prime" style={{height:'3px',maxWidth:'200px',width:'100%'}}></div>
                          <Link to="/plandeposit2" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px'}}>
                              <FontAwesomeIcon icon={faArrowUpFromBracket} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-nowrap text-prime" style={{fontSize:'12px'}}>Payment Proof</p>
                          </Link>
                          <div className="bg-prime" style={{height:'3px',maxWidth:'200px',width:'100%'}}></div>
                          <Link to="/plandeposit3" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px'}}>
                              <FontAwesomeIcon icon={faCircleCheck} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-nowrap text-prime" style={{fontSize:'12px'}}>Review & Submit</p>
                          </Link>
                        </div>
                        <div className="mycard p-3 mt-4">
                          <div className="row">
                            <div className="col-12 largeSelect">
                              <h5 className="mb-4" style={{fontWeight:'900'}}>Review Your Deposit</h5>
                              <div className="mb-4 mycard p-3">
                                <div className="d-flex align-items-center justify-content-between mb-3">
                                    <p className="mb-0 text-secondary fw-semibold">Method</p>
                                    <p className="mb-0 fw-bold">{method}</p>
                                </div>
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="mb-0 text-secondary fw-semibold">Amount </p>
                                    <p className="mb-0 fw-bold">{amount} {symbol}</p>
                                </div>
                              </div>
                              <div className="mycard p-3 rounded-2" style={{backgroundColor:'#ff6b350d'}}>
                                <p className="mb-0 text-prime" style={{fontSize:'14px'}}>Your deposit will be review within 1-24 hours. You'll receive an email confirmation once approved.</p>
                              </div>
                              <hr/>
                              <div className="d-flex justify-content-end">
                                <div className={`myBtn mt-4 text-center px-4 py-3 rounded-2`} onClick={fee ? ValidateDeposit1 : ValidateDeposit}>{loading1?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Submit Deposit'}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Deposit4